
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsroom/refute-news",
      function () {
        return require("private-next-pages/newsroom/refute-news.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsroom/refute-news"])
      });
    }
  